import { Button } from '@material-ui/core';
import { getAgentById } from '@nemuru-eng/js-api-client';
import React, { useState } from 'react';
import { useParams } from 'react-router-dom';

import { MoreActionsMenu } from '@/components/shared/components/MoreActionsMenu/MoreActionsMenu';
import { ActionsOption } from '@/components/shared/components/MoreActionsMenu/types/ActionsOption';
import { useDialog } from '@/components/shared/hooks/useDialog';
import { Font } from '@/components/shared/components/Font';
import { Text } from '@/components/shared/components/Text';
import { AgentDetailDialog } from '@/components/widgets/AgentDetailActions/components/AgentDetailDialog';
import { AgentDetailAction } from '@/components/widgets/AgentDetailActions/types/AgentDetailAction';
import { useGetMerchantStructureById } from '@/hooks/requests/merchant/useGetMerchantStructureById';
import { useCache } from '@/hooks/requests/useCache';

export const AgentDetailActions: React.FC = () => {
  const { agentId, merchantId } = useParams();

  if (!agentId || !merchantId) return null;

  const { data: agent } = useCache(getAgentById, { agentId });
  const { merchantStructure } = useGetMerchantStructureById(merchantId);

  const [currentAction, setCurrentAction] = useState<AgentDetailAction | undefined>();

  const { opened, setOpened, toggleDialog } = useDialog();

  const toggleActionDialog = (actionType: AgentDetailAction) => {
    setCurrentAction(actionType);
    toggleDialog();
  };

  const actions: ActionsOption[] = [
    {
      display: <Text tId={'CLONE_AGENT_MENU'} />,
      onClick: () => toggleActionDialog(AgentDetailAction.CLONE_AGENT),
      iconName: 'content_copy',
    },
    {
      display: <Text tId={'UPDATE_AGENT_MENU'} />,
      onClick: () => toggleActionDialog(AgentDetailAction.UPDATE_AGENT),
      iconName: 'content_copy',
    },
  ];

  if (merchantStructure && merchantStructure.merchant.channels.length > 1) {
    actions.push({
      display: <Text tId={'CHANGE_TO_ANOTHER_CHANNEL'} />,
      onClick: () => toggleActionDialog(AgentDetailAction.CHANGE_TO_ANOTHER_CHANNEL),
      iconName: 'swap_horiz',
    });
  }

  return (
    <>
      <MoreActionsMenu actionsOptionsArray={actions}>
        <Button>
          <Font variant={'subtitle2'} color={'textSecondary'}>
            <i
              className={'material-icons-outlined mr-2'}
              style={{ verticalAlign: '-5px', marginLeft: '-4px', fontSize: '1.5em' }}
            >
              menu
            </i>
            <Text tId={'ACTIONS'} />
          </Font>
        </Button>
      </MoreActionsMenu>
      {currentAction && (
        <AgentDetailDialog
          currentAction={currentAction}
          agent={agent}
          merchantStructure={merchantStructure}
          opened={opened}
          setOpened={setOpened}
          toggleDialog={toggleDialog}
        />
      )}
    </>
  );
};
